<template>
  <div>
    <template v-if="schema.name == 'navBar' && pluginIndex == 0">
      <template v-if="!isWeixin">

        <div class="safe-margin-top" v-if="schema.placeholder && schema.fixed">
          <!-- 透明顶 填充 -->
        </div>

        <van-nav-bar :style="'background-color: ' + (schema.transparent ? schema.bgColor + '50' : schema.bgColor) + ';'"
          :fixed="schema.fixed" :border="false" :safe-area-inset-top="pluginIndex == 0">
          <div slot="left" v-if="schema.showLeft">
            <van-icon :name="schema.leftIcon || 'wap-home-o'" size="18" class="left-home-white"
              @click="actionPlugin"></van-icon>
          </div>
          <div slot="title" :style="'color: ' + schema.color + ';'">{{ schema.text }}</div>
        </van-nav-bar>
      </template>

    </template>
    <template v-else-if="schema.name == 'navBar'">
      <van-nav-bar :style="'background-color: ' + (schema.transparent ? schema.bgColor + '50' : schema.bgColor) + ';'"
        :border="false">
        <div slot="left" v-if="schema.showLeft">
          <van-icon :name="schema.leftIcon || 'wap-home-o'" size="18" class="left-home-white"
            @click="actionPlugin"></van-icon>
        </div>
        <div slot="title" :style="'color: ' + schema.color + ';'">{{ schema.text }}</div>
      </van-nav-bar>
    </template>

  </div>

</template>

<script>
// import { Notify } from 'vant';
import utils from "../../../utils/utils"

export default {
  name: 'navBar',
  props: {
    schema: {
      'type': Object,
      default: {},
      required: true
    },
    pluginIndex: {
      type: Number,
      default: 0
    }
  },
  data: function () {
    return {
      isWeixin: utils.isWeixin(),
    }
  },
  methods: {

    actionPlugin() {
      this.$store.commit('actionPlugin', {
        pluginIndex: this.pluginIndex
      })
    }
  }
}
</script>

<style>
.van-nav-bar {
  z-index: 2 !important;
}

.safe-margin-top {
  margin-top: constant(safe-area-inset-top);
  margin-top: env(safe-area-inset-top);
  height: 46px;
}

/* .left-home-black{background-color:#00000040; color:#ffffff !important; padding:5px;border-radius:50px;border:1px solid #e6e6e650;} */
.left-home-white {
  background-color: #ffffff95;
  color: #000000 !important;
  padding: 5px;
  border-radius: 50px;
  border: 1px solid #acabab50;
}
</style>